<template>
  <section ref="counters" class="counters__inner">
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-54XLG6X"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe>
    </noscript>
  </section>
</template>
<script>
export default {
  name: "MycomCounters",

  data() {
    return {};
  },

  mounted() {
    let counters = this.$refs.counters;

    let google_counter = document.createElement("script");
    google_counter.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-54XLG6X');`;
    counters.appendChild(google_counter);

    // let gtag_manager = document.createElement("script");
    // gtag_manager.setAttribute("src", "https://wf.my.com/static/wf.my.com/js/main/gtag_manager.js");
    // counters.appendChild(gtag_manager);

    let one_link = document.createElement("script");
    one_link.setAttribute("src", "https://wf.my.com/static/wf.my.com/js/1link_processing.js");
    counters.appendChild(one_link);
  },
};
</script>
